import type { CSSProperties } from 'react';
import type { ChatPresence } from '../../api/client';
import { Icon } from '../../lib/icons';
import { initials } from '../../lib/session';
import { pictureUrl, usePictureOf } from '../../lib/pictures';

/** A colour per person, so a busy channel is easy to follow. */
export function hueOf(id: string): number {
  let h = 7;
  for (const ch of id) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return h;
}

/** Someone's picture (else their initials in their colour), with how they show now (online, idle, do not disturb, offline, or on a call). */
export function Avatar({ id, name, small, outside, presence }: { id: string; name: string; small?: boolean; outside?: boolean; presence?: (Pick<ChatPresence, 'status'> & { phone?: ChatPresence['phone'] }) | undefined }) {
  const version = usePictureOf(outside ? null : id);
  return (
    <span className={`msg-avatar${small ? ' small' : ''}${outside ? ' outside' : ''}${version ? ' has-picture' : ''}`} style={{ '--msg-hue': hueOf(id) } as CSSProperties} aria-hidden="true">
      {outside ? <Icon name="phone" size={small ? 11 : 15} /> : version ? <img src={pictureUrl(id, version, small ? 'small' : 'medium')} alt="" loading="lazy" decoding="async" /> : initials(name)}
      {presence &&
        (presence.phone?.state === 'talking' ? (
          // On a call, wherever it is (a desk phone, an app, Stitch, a Patch): that's what shows.
          <span className="msg-dot oncall">
            <Icon name="phone" size={small ? 6 : 8} />
          </span>
        ) : (
          <span className={`msg-dot ${presence.status}`} />
        ))}
    </span>
  );
}
